import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@chakra-ui/react'
import useStore from '../../../store'
import { colors } from '../../../utilities/colors'
import ActionConfirmDrawer from '../../common/ActionConfirmDrawer'
import { isCarpoolOrderCancelable } from '../shared/vehicleStatus'
import useTransportationBasePath from '../../../hooks/useTransportationBasePath'

export default function CancelOrderButton({ order }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useTransportationBasePath()
  const cancelCarpoolOrder = useStore((state) => state.cancelCarpoolOrder)
  const [isOpen, setIsOpen] = useState(false)
  const [isCancelling, setIsCancelling] = useState(false)

  if (!isCarpoolOrderCancelable(order)) return null

  const handleConfirm = async () => {
    setIsCancelling(true)
    try {
      await cancelCarpoolOrder(order.id)
      setIsOpen(false)
      navigate(`${basePath}/orders`)
    } catch {
      setIsCancelling(false)
    }
  }

  return (
    <Box display="flex" justifyContent="center" w="full" pt={2}>
      <Button
        variant="unstyled"
        onClick={() => setIsOpen(true)}
        color={colors.fpxRed}
        fontWeight="medium"
        _hover={{ opacity: 0.75, cursor: 'pointer' }}
      >
        {t('Cancel this Order')}
      </Button>
      <ActionConfirmDrawer
        title={t('Cancel Order')}
        body={t('Are you sure you want to cancel this transport order?')}
        isOpen={isOpen}
        showSpinner={isCancelling}
        onClose={() => setIsOpen(false)}
        onConfirm={handleConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </Box>
  )
}
